import * as React from 'react';
import { SVGProps } from 'react';

const IconStrikethroughSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 1H2v2h3v2h2V3h3V1ZM11 6H1v1h10V6ZM5 8v3h2V8H5Z" />
  </svg>
);
export default IconStrikethroughSizeXs;
